import { useState } from "react";
import MapPicker from "./MapPicker";
import { generateGoogleMapUrl, getUserLocation } from "../../lib/utils";
import { ButtonWithLoader } from "../ui/buttonwithloader";
import CommonPopup from "@/components/popups/commonPopup";
import { Check, CheckCircle2, Copy, Link2, MapPin, Navigation } from "lucide-react";
import { Button } from "../ui/button";

type LocationCoords = {
  lat: number | any;
  lng: number | any;
}


type LocationPickerProps = {
  handleConfirmLocation: (coords:LocationCoords) => void ;
  handleLocationReset:()=>void;
  address:any;

};
const LocationPicker = ({handleConfirmLocation,handleLocationReset,address}:LocationPickerProps) => {
  const [location, setLocation] = useState<LocationCoords | null>(null);
  const [locationConfirmed, setLocationConfirmed] = useState(!!address?.googleLocationURL);
  const [error, setError] = useState<string | null>(null);
  const [showMap,setShowMap] = useState(false)
  const [selectedVenueLinkForCopy,setSelectedVenueLinkForCopy] = useState(null)
  const [copied, setCopied] = useState(false);

  const handleGetLocation = async () => {
    try {
      const coords = await getUserLocation();
      setLocation(coords as LocationCoords);
      setError(null);
      setShowMap(true)
    } catch (err) {
      setError("Location access denied. Please enable location.");
    }
  };


  const handleConfirmCurrentLocation=async()=>{
    try {
      const coords = await getUserLocation();
      setLocation(coords as LocationCoords);
      confirmHandler(coords as LocationCoords)
      setError(null);
    } catch (err) {
      setError("Location access denied. Please enable location.");
    }
  }


  const onLocationSelectHandler=(coords:any)=>{
    console.log("My loaction cord:",coords)
    setLocation(coords)
  }

  const confirmHandler=(coords?:LocationCoords)=>{
    if((location?.lat && location.lng) || (coords.lat && coords.lng) ){
      if(coords){
        handleConfirmLocation(coords)
      }else{
        handleConfirmLocation(location)
      }
      setLocationConfirmed(true)
      setShowMap(false)
    }
  }
  const renerMapModal=()=>{
    return <CommonPopup
    description={ 
      <MapPicker
       initialLocation={location} 
        onLocationSelect={onLocationSelectHandler}
        confirmHandler={confirmHandler}
        />
    }
    // mainclassName="w-"
    headerIcon={<MapPin className="w-5 h-5"/>}
    isOpen={showMap && !!location}
    title={"Select Your Venue Location"}
    proceedBtnTitle='Confirm'
    onClose={()=>setShowMap(false)}
    showfooter={false}

    

    />
  }



  const handleCopy = async (url:string) => {
    setSelectedVenueLinkForCopy(url)
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => {
      setCopied(false)
      setSelectedVenueLinkForCopy(null)
    }, 1000);
  };


  return (
<>

{showMap && !!location && renerMapModal()}

    <div>
      {/* Map Placeholder */}
      <div className="rounded-2xl overflow-hidden border border-flup-hairline shadow-sm">
            <div className="relative bg-gradient-to-br from-emerald-50 to-blue-50 h-44 flex flex-col items-center justify-center gap-3">
              {/* Decorative grid */}
              <div className="absolute inset-0 opacity-10 pointer-events-none"
                style={{
                  backgroundImage: "linear-gradient(rgba(0,0,0,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.1) 1px, transparent 1px)",
                  backgroundSize: "30px 30px",
                }}
              />
              <div className="relative w-12 h-12 rounded-full bg-flup-surface shadow-md flex items-center justify-center">
                <MapPin className="w-6 h-6 text-emerald-500" />
              </div>
              {!locationConfirmed &&<p className="relative text-sm text-flup-ink-3 font-medium">
                {"Pin your venue location"}
              </p>}

              {!locationConfirmed && <div className="flex items-center justify-center gap-4">

                <Button
                  onClick={handleConfirmCurrentLocation}
                  variant="outline"
                  className="relative rounded-full w-[200px] px-5 h-9 text-xs font-semibold border-emerald-200 text-emerald-700 hover:bg-emerald-50 gap-1.5 hover:text-flup-info"
                >
                  <Navigation className="w-3.5 h-3.5" />
                  Use Current Location
                </Button>

                <Button
                  onClick={handleGetLocation}
                  variant="outline"
                  className="relative w-[200px] rounded-full px-5 h-9 text-xs font-semibold border-emerald-200 text-emerald-700 hover:bg-emerald-50 gap-1.5 hover:text-flup-info"
                >
                  <MapPin className="w-3.5 h-3.5" />
                  Select From Map
                </Button>
                </div>}

                {(location && locationConfirmed )? <div className="flex items-center gap-2 text-sm">
                    <Link2 className="w-4 h-4 text-flup-violet" />
                    <a
                      href={generateGoogleMapUrl(location.lat,location.lng)}
                      className="text-flup-violet hover:underline truncate text-sm truncate w-[400px]"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {generateGoogleMapUrl(location.lat,location.lng)}
                    </a>

                    <button
                      onClick={()=>handleCopy(generateGoogleMapUrl(location.lat,location.lng))}
                      className="ml-auto text-flup-ink-3 hover:text-flup-violet transition-colors"
                      aria-label="Copy booking link"
                    >
                      {copied ? (
                        <Check className="w-4 h-4 text-green-500" />
                      ) : (
                        <Copy className="w-4 h-4" />
                      )}
                    </button>
                    </div>:
                   address?.googleLocationURL &&<div className="flex items-center gap-2 text-sm">

                  <Link2 className="w-4 h-4 text-flup-violet" />
                    <a
                      href={ address?.googleLocationURL}
                      className="text-flup-violet hover:underline truncate text-sm truncate w-[400px]"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      { address?.googleLocationURL}
                    </a>

                    <button
                      onClick={()=>handleCopy(generateGoogleMapUrl(location.lat,location.lng))}
                      className="ml-auto text-flup-ink-3 hover:text-flup-violet transition-colors"
                      aria-label="Copy booking link"
                    >
                      {copied ? (
                        <Check className="w-4 h-4 text-green-500" />
                      ) : (
                        <Copy className="w-4 h-4" />
                      )}
                    </button>
                    </div>
                    }
              {locationConfirmed && (
                <>
                    <div className="relative flex items-center gap-1.5 text-emerald-600 text-xs font-semibold">
                  <CheckCircle2 className="w-4 h-4" />
                  Location set successfully
                </div>

              


                   <Button
                  onClick={()=>{
                    setLocationConfirmed(false)
                    setLocation(null)
                    handleLocationReset()
                  }}
                  variant="outline"
                  className="relative w-[200px] rounded-full px-5 h-9 text-xs font-semibold border-emerald-200 text-emerald-700 hover:bg-emerald-50 gap-1.5 hover:text-flup-info"
                >
                  <MapPin className="w-3.5 h-3.5" />
                  Change location
                </Button>
                </>
            
              
              
              )}




            </div>
          </div>
        </div>



          {error && <p style={{ color: "red" }}>{error}</p>}
        </>
  );
};

export default LocationPicker;
